<body>
  <div class="container-scroller">
    <div class="container-fluid page-body-wrapper">


      <!-- Stack -->
      <app-top-bar></app-top-bar>
      <app-side-bar></app-side-bar>
      <app-right-bar></app-right-bar>
      <!-- Stack -->


      <div class="main-panel">


        <!-- --------------- - Main Panel - ----------------- -->
        <router-outlet></router-outlet>
        <!-- --------------- - Main Panel - ----------------- -->

        <!-- ---------------- - - - - --------------------- -->

        <!-- --------------- - Footer Panel - ----------------- -->
        <app-dashboard-footer></app-dashboard-footer>
        <!-- --------------- - Footer Panel - ----------------- -->


      </div>


    </div>
  </div>
</body>
